<template>
    <div>
        <v-form ref="formDatos" lazy-validation>
            <v-row v-if="estadoComp">
                <v-col cols="12" class="d-flex justify-end">
                    <ButtonComp text-button="Volver" iconBut="fas fa-arrow-left" classColor="red"
                        @click="closeComp()" />
                </v-col>
                <v-col cols="12">
                    <v-chip label>{{ formTitle }}</v-chip>
                </v-col>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card outlined>
                                <v-card-text>
                                    <v-row dense>
                                        <v-col cols="12" md="4" lg="4">
                                            <v-select label="Opciones de respuesta" v-model="datos.id_tipo_pregunta"
                                                :items="listTipoPregunta" item-value="id" item-text="desc_pregunta"
                                                :rules="[rul.selectReq]"
                                                @change="eventTipoPregunta(datos.id_tipo_pregunta)"
                                                :disabled="disableForm">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" md="4" lg="4">
                                            <v-select label="Tema" v-model="datos.id_programacion"
                                                :items="listProgramacionDoc" item-value="id" item-text="nombre_clase"
                                                :rules="[rul.selectReq]" :disabled="disableForm" @change="loadDataComp">
                                            </v-select>
                                        </v-col>
                                        <!-- <v-col cols="12" md="4" lg="4">
                                            <v-select label="Plantilla" v-model="datos.id_plantilla"
                                                :items="listPlantilla" item-value="id" item-text="nombre_template"
                                                :rules="[rul.selectReq]" :disabled="disableForm" @change="loadDataComp">
                                            </v-select>
                                        </v-col> -->
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <component :is="compName" :estadoComp="estadoModalConfig" :parametros="parametroConfig"
                                @close="closeComp">
                            </component>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios"
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ButtonComp from "../../../../../components/ComponentsEst/TableButtonComp.vue";

import PregPUComp from './pregPU'
import PregPMComp from './pregPM'
import PregPVComp from './pregPV'
import PregPDComp from './pregPD'

export default {
    name: 'PreguntaFormulario',

    components: {
        ButtonComp,
        PregPUComp,
        PregPMComp,
        PregPVComp,
        PregPDComp
    },
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },


    data: () => ({

        datoLogin: sessionStorage,
        evento: null,
        test: false,
        datos: {},
        paramComponente: { 'id_submodulo': 22, "id_modulo": 4 },

        compName: null,
        estadoModalConfig: true,
        parametroConfig: [],

        rutaServer: API_URL,
        inhabilitarButton: false,
        disableForm: false,
        filter: {},

        listTipoPregunta: [

            { id: "", desc_pregunta: "Seleccione ..." },
            { id: "PU", desc_pregunta: "Única" },
            { id: "PM", desc_pregunta: "Múltiple" },
            { id: "PV", desc_pregunta: "Verdadero o falso" },
            { id: "PD", desc_pregunta: "Desarrollo" },
        ],

        listProgramacionDoc: [],
        listPlantilla: [],



        //validaciones de formulario
        rul: {
            required: value => !!value || 'Campo Requerido',
            inputReq: value => !!value || 'Campo Requerido',
            selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
            email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
            min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
            min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
            min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
            max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
            max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
            max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
            max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
            max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
            max40: v => (v || '').length <= 40 || 'Máximo 40 caracteres',
            max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
            max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
            max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
            max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

            email_null: value => {
                if (value == '') {
                    return false
                }
                else {
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    return pattern.test(value) || 'El correo Electrónico es incorrecto'
                }
            },

            hora: value => {
                if (value < '00:01') {
                    return 'El formato de la hora ingresada es incorrecto'
                }
                else {
                    if (value >= '23:59') {
                        return 'El formato de la hora ingresada es incorrecto'
                    }
                }
            },
        },

    }),

    mounted() {
        this.loadMain()
    },

    //computadas
    computed: {

        ...mapGetters('login', ['componenteEvento']),

        formTitle() {
            //return this.parametros.evento === 'add' ? 'AGREGAR REGISTRO DE INCIDENCIA CONDUTUAL' : 'EDITAR REGISTRO DE INCIDENCIA CONDUTUAL'
            return 'Preguntas de evaluación'
        },

        computedDateFormatted2() {
            return this.formatDate(this.datos.fecha)
        },


    },


    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoComp() {

            if (this.estadoComp) {
                this.loadMain()
            } else {
                //this.parametros = {}
                this.limpiarForm()

            }
        }
    },

    methods: {

        ...mapActions('login', ['parametroComponente']),

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        // Maxima Fecha Calendario fecha actual
        // getEndDate(){
        //     return  moment().format('YYYY-MM-DD')
        // },

        //  ------- input tipo fecha  --------
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },


        loadMain() {
            this.limpiarForm();


            this.getProgramacionDoc();
            this.getPlantilla();

            this.datos.id_programacion = this.parametros.items.id_programacion
            this.datos.id_evaluacion = this.parametros.items.id
            this.datos.id_docente = this.parametros.items.id_docente

            if (this.parametros.evento == 'add') {
                this.loadDataComp();
            }

            if (this.parametros.evento == 'edit') {
                this.editItem(this.parametros.items)
            }

            if (this.parametros.evento == 'view') {
                this.disableForm = true;
                this.editItem(this.parametros.items)
            }

        },

        async editItem(items) {

            this.datos.id_tipo_pregunta = items.id_tipo_pregunta
            this.datos.id_programacion = items.id_programacion
            this.datos.id = items.id
            this.datos.id_dificultad = items.id_dificultad
            this.datos.titulo = items.titulo
            this.datos.color_fondo_titulo = items.color_fondo_titulo
            this.datos.pregunta = items.pregunta
            this.datos.color_fondo_pregunta = items.color_fondo_pregunta
            this.datos.compartir = items.compartir
            this.datos.orden = items.orden

           
            if (items.titulo == '<span style="font-size:36px">Ingrese un titulo</span>') {
                this.datos.titulouse = false
               
            } else {
                this.datos.titulouse = true
               
            }

            this.eventTipoPregunta(items.id_tipo_pregunta)
            this.datos.id_plantilla = items.id_plantilla
            this.loadDataComp()


        },



        //-------mostrar registros------------
        async getProgramacionDoc() {

            //   "id_colegio": "238", "id_ano_lectivo": "110"   id_programacion
            try {
                let params = { id_colegio: this.parametros.items.id_colegio, id_ano_lectivo: this.parametros.items.id_ano_lectivo, id_programacion: this.parametros.items.id_programacion }
                let response = await axios.post(`/academico/progDocente/view/`, { filter: params })
                this.listProgramacionDoc = response.data
             
                if (this.listProgramacionDoc.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }
            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },



        async getPlantilla() {

            try {

                let response = await axios.post(`/administrativo/contenido/getTemplate/`, { filtro: { id_colegio: sessionStorage.id_colegio, estado_template: 1, tipo: 2 } })
                let objectNew = JSON.parse(JSON.stringify(response.data))

                objectNew.unshift({
                    "id": -1,
                    "nombre_template": "Ninguno",
                })

                this.listPlantilla = objectNew

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },


        eventTipoPregunta(tipoPregunta) {

            //this.setEnviarMens({tipo:"W", mensaje: `Load  Componente: ${comp}`, tiempo:null})
            let comp = `Preg${tipoPregunta}Comp`
            this.datos.id_plantilla = -1
            this.datos.id_valor = this.parametros.items.id_valor
            this.parametroConfig = { evento: this.parametros.evento, item: this.datos }
            this.compName = comp
            this.estadoModalConfig = true

        },


        loadDataComp() {
            this.parametroConfig = { evento: this.parametros.evento, item: this.datos }
        },


        resetValidation() {
            this.$refs.formDatos.resetValidation()
        },


        closeComp() {

            console.log("close componente (preguntaFomComp) ")
            this.estadoModalConfig = false
            this.compName = null
            this.$emit('close')
        },


        limpiarForm() {
            //    num_documento:77889966, num_documento2:55887745,                
            this.datos = {
                id: null,
                id_us: this.datoLogin.id,
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_evaluacion: "",
                id_programacion: "",
                id_docente: "",
                id_plantilla: -1,
                id_tipo_pregunta: '',
                id_dificultad: 0,
                titulo: '',
                color_fondo_titulo: "",
                pregunta: '',
                color_fondo_pregunta: "",
                compartir: false,
                respuestas: [],
                orden: null,
                status: true,
                id_usuario: this.datoLogin.id



            }

            this.disableForm = false
            this.resetValidation()

        },


    },
}
</script>
<style scoped></style>